import useSWR from "swr";
import { getCustomerSalesRep } from "../services/prospect";
import { useAppSelector } from "../store";

const useCustomerSalesRep = () => {
  const proposalToken = useAppSelector((state) => state.auth.proposalToken);
  return useSWR(["customerSalesRep", proposalToken], ([, proposalToken]) => {
    if (!proposalToken) return;
    return getCustomerSalesRep(proposalToken);
  });
};

export { useCustomerSalesRep };
